<template>
    <div class="page-content header-clear-medium">

		<div v-if="loading">		
			<div class="card card-style">
				<div class="content">
					<!-- <PuSkeleton :height="400" /> -->
					<vue-skeleton-loader
						:height="250"
						animation="fade" 
						class="w-100 rounded-s"
					/>
				</div>
			</div>

			<div class="card card-style">
				<div class="content">
					<div class="row mb-2">
						<div class="col-4">
							<vue-skeleton-loader
								:height="125"
								animation="fade" 
								class="w-100 rounded-s"
							/>
						</div>
						<div class="col-4">
							<vue-skeleton-loader
								:height="125"
								animation="fade" 
								class="w-100 rounded-s"
							/>
						</div>
						<div class="col-4">
							<vue-skeleton-loader
								:height="125"
								animation="fade" 
								class="w-100 rounded-s"
							/>
						</div>
					</div>
				</div>
			</div>
			
			<!-- <content-skeleton count="5"></content-skeleton> -->
		</div>
		<div v-else class="card card-style">
			<div class="card-body px-0 py-0">
				<!-- <h6 class="font-700 opacity-60 content mb-2">Single Boxed Slider - with Arrows and Dots</h6> -->
				<div class="splide splide-custom single-slider slider-dots-under slider-boxed" id="single-slider-1">
					<div class="splide__track">
						<div class="splide__list">
							
							<div class="splide__slide" v-for="item in homepage_post" :key="item.id">
								<router-link :to="{ name: 'news' }">
									<div data-card-height="400" class="card bg-11 rounded-m shadow-l" :style="{ 'background-image': 'url('+item._embedded['wp:featuredmedia'][0]['source_url']+')', 'object-fit': 'fill' }">
										<div class="card-bottom text-center m-3">
											<h2 class="color-white text-uppercase font-900 mb-3" v-html="item.title.rendered"></h2>
											<p class="under-heading color-white opacity-60 mb-0" v-html="item.excerpt.rendered.replace(/(<p[^>]+?>|<p>|<\/p>)/img, '')"></p>
										</div>
										<div class="card-overlay rounded-m bg-gradient-fade opacity-90"></div>
									</div>
								</router-link>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-fluid">
		<div v-if="!loading" class="row mb-2">
			<!-- <div class="col-4" style="padding-right:0;padding-left:0;"> -->
			<div class="col-4">
				<router-link :to="{ name: 'presence' }">
					<div class="card card-style bg-blue-light mx-0">
						<div class="card-body text-center badge-container">
							<!-- <i class="bi bi-bootstrap-fill color-magenta-dark font-50 d-block pb-2"></i> -->
							<!-- <em v-if="postsReadLocal.length < post.total" class="badge bage-number bg-yellow-dark">{{ post.total - postsReadLocal.length }}</em> -->
							<i class="bi bi-calendar2-check font-50 d-block pb-2"></i>
							<h6 class="pt-2 font-200 color-white">Presensi</h6>
						</div>
					</div>
				</router-link>
			</div>
			<!-- <div class="col-4" style="padding-right:0;padding-left:0;"> -->
			<div class="col-4">
				<router-link :to="{ name: 'tatib' }">
					<div class="card card-style bg-pink-light mx-0">
						<div class="card-body text-center badge-container">
							<!-- <em v-if="announcementsReadLocal.length < announcements.total" class="badge bage-number bg-yellow-dark">{{ announcements.total - announcementsReadLocal.length }}</em> -->
							<i class="bi bi-hammer font-50 d-block pb-2"></i>
							<h6 class="pt-2 font-200 color-white">E-Tatib</h6>
						</div>
					</div>
				</router-link>
			</div>
			<!-- <div class="col-4" style="padding-right:0;padding-left:0;"> -->
			<div class="col-4">
				<router-link :to="{ name: 'spp' }">
					<div class="card card-style bg-green-light mx-0">
						<div class="card-body text-center badge-container">
							<!-- <em v-if="eventsReadLocal.length < events.total" class="badge bage-number bg-yellow-dark">{{ events.total - eventsReadLocal.length }}</em> -->
							<i class="bi bi-credit-card font-50 d-block pb-2"></i>
							<h6 class="pt-2 font-200 color-white">E-SPP</h6>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		</div>
        
    </div>
</template>

<script>
import { 
	mapMutations, 
	mapActions, mapState 
} from 'vuex'
// import ReportFilter from '../components/form/ReportFilter.vue'
// import TableSkeleton from "../components/skeleton/TableSkeleton.vue";
// import ContentSkeleton from "../components/skeleton/ContentSkeleton.vue";
// import moment from 'moment'

export default {
    name: 'Home',
    components: {
		// ReportFilter, 
		// ContentSkeleton
    },
    data() {
        return {
			// presenceDate: moment().format('YYYY-MM-DD'),
        }
    },
    async created() {
		this.SET_LOADING()
        await this.getHomepagePost()
		await this.getStudentMe()
		this.CLEAR_LOADING()
    },
	mounted() {
		this.$nextTick(function () {
			// do stuff with the DOM
			document.refreshSlider()
		})
	},
	updated() {
		this.$nextTick(function () {
			// do stuff with the DOM
			document.refreshSlider()
		})
	},
    methods: {
        ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
		...mapActions('postWp', ['getHomepagePost']),
		...mapActions('studentMe', ['getStudentMe']),
    },
    computed: {
        ...mapState({
            loading: state => state.loading
        }),
		...mapState('postWp', {
			homepage_post: state => state.homepage_post,
		}),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }

.badge-container .bage-number{
    height: 30px;
    min-width: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    border-radius: 15px;
    text-align: center;
    padding: 0px;
    position: absolute;
    margin-top: 0px;
    transform: translateX(4px);
    z-index: 3;
    top: -5px;
    right: -5px;
}
</style>
